import { render } from "./BannerFive.vue?vue&type=template&id=2dd3e2d0"
const script = {}

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__